import React from "react";
import FigmaIcon from "./FigmaIcon";
export default function AssignTeamPillIcon(props) { return <FigmaIcon name="assignTeam" {...props} />; }
